import {
  EyeIcon,
  EditIcon,
  AddUserIcon,
  PublishIcon,
  ExportIcon,
  LogIcon,
  DeleteIcon,
  InfoFilled,
  UnlockIcon,
} from "../components/common/Icons";

export const getDraftPlanMenu = (
  row,
  userProfile,
  isAdmin,
  {
    onView,
    onEdit,
    onManageUsers,
    onPublish,
    onConfirmPublish,
    onDelete,
    onConfirmDelete,
    onExport,
    onAuditLog,
    onUnlock,
  }
) => {
  const isLocked = row.locked_by !== null;
  const isCurrentUserLocked = row.locked_by?.id === userProfile.id;
  // show the tooltip for the other users who is not locked the care plan as it is locked
  // if the current user is admin, show the unlock option
  if (isLocked && !isCurrentUserLocked) {
    const items = [
      {
        label: `Care plan locked by ${row.locked_by.name}`,
        icon: <InfoFilled />,
        action: () => {},
        disabled: true,
      },
    ];
    if (isAdmin) {
      items.push({
        label: "Unlock care plan",
        icon: <UnlockIcon color="#0065C0" />,
        action: () => onUnlock(row),
        color: "#0065C0",
      });
    }
    return items;
  }

  return [
    { label: "View Draft Plan", icon: <EyeIcon />, action: () => onView(row) },
    { label: "Edit", icon: <EditIcon />, action: () => onEdit(row) },
    {
      label: "Plan Access",
      icon: <AddUserIcon />,
      action: () => onManageUsers(row),
    },
    {
      label: "Publish Plan",
      icon: <PublishIcon />,
      action: () => onPublish(row),
    },
    { label: "Print View", icon: <ExportIcon />, action: () => onExport(row) },
    { label: "Audit Log", icon: <LogIcon />, action: () => onAuditLog(row) },
    { label: "Delete Plan", icon: <DeleteIcon />, action: () => onDelete(row) },
  ];
};
